import React from 'react'

import Section from '../../../react4xp/components/Section'
import Mask from '../../../react4xp/components/Mask'
import Video from '../../../react4xp/components/Video'


function HeroPart({title, video, bgColor, maskColor}) {
	return video && (
		<Section bgColor={bgColor} className='page-recipe__video'>
			<div className='container'>
				<Mask bgColor={maskColor} spacing='small'>

					{title && (
						<h2 className='h3'>
							{title}
						</h2>
					)}

					<div className='video-outer-wrapper'>
						<Mask maskDistortion='low'>
							<Video
								video={{
									...video,									
									playButtonColor: 'blue',
									playTextColor: 'white',
								}}
								className='cover'
							/>
						</Mask>
					</div>
				</Mask>
			</div>
		</Section>
	)
}

export default (props) => <HeroPart {...props} />
